// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__hroHW","left":"StickyBox_left__3t9dQ","right":"StickyBox_right__2im2X"};